class ThreeSixty {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this.images = []
        this.attributes = this.setAttributes()
        this.firstPlay = false
        this.settings = this.setSettings(elem.dataset.threeSixty)
        this.initialise = elem.dataset.threeSixtyInit === ''
    }

    onInit () {
        if (!this.initialise) {
            return false
        }
        this.init()
    }

    init () {
        this.preloadImgs()
    }

    preloadImgs (initial) {
        let imgCount = parseInt(this.settings.count)
        let loadCount = 0
        for (let i = 0; i <= imgCount; i++) {
            let newIndex = i < 10 ? `0${i}` : '' + i
            let newUrl = `${this.settings.url}-${newIndex}.${this.settings.type}`
            this.makeRequest(newUrl).then(e => {
                this.images[i] = newUrl
                loadCount++
                if (loadCount === imgCount + 1) {
                    this.createSwitcher()
                    window.addEventListener('load', e => {
                        if (this.firstPlay) return false
                        this.firstPlay = true
                        this.fullSpin()
                    })
                    this.switcher.addEventListener('load', e => {
                        if (this.firstPlay) return false
                        this.firstPlay = true
                        this.fullSpin()
                    })
                }
            })
        }
    }

    createSwitcher () {
        this.switcher = document.createElement('img')
        this.switcher.draggable = false
        this.switcher.src = this.images[this.attributes.index]
        this.settings.appendTo.appendChild(this.switcher)
        this.switcher.addEventListener('mousedown', e => {
            e.preventDefault()
        })
        this.attachEvents()
    }

    attachEvents () {
        let onElem = false
        let movedBy = 0
        let oldPos = 0
        let newPos = 0
        this._elem.addEventListener('mousedown', e => {
            this.stop()
            this._elem.classList.add('active')
            movedBy = 0
            onElem = true
            oldPos = e.clientX
        })
        this._elem.addEventListener('touchstart', e => {
            this.stop()
            this._elem.classList.add('active')
            movedBy = 0
            onElem = true
            oldPos = e.touches[0].clientX
        })
        window.addEventListener('mousemove', e => {
            if (!onElem) return false
            newPos = e.clientX
            movedBy = newPos - oldPos
            if (movedBy > 5) {
                oldPos = e.clientX
                this.changeSrc(true)
            } else if (movedBy < -5) {
                oldPos = e.clientX
                this.changeSrc(false)
            }
        })
        window.addEventListener('touchmove', e => {
            if (!onElem) return false
            newPos = e.touches[0].clientX
            movedBy = newPos - oldPos
            if (movedBy > 5) {
                oldPos = e.touches[0].clientX
                this.changeSrc(true)
            } else if (movedBy < -5) {
                oldPos = e.touches[0].clientX
                this.changeSrc(false)
            }
        })
        window.addEventListener('mouseup', e => {
            if (!onElem) return false
            this._elem.classList.remove('active')
            onElem = false
        })
        window.addEventListener('touchend', e => {
            if (!onElem) return false
            this._elem.classList.remove('active')
            onElem = false
        })
    }

    changeSrc (inc, fullSpin) {
        this.attributes.index = inc ? this.attributes.index + 1 : this.attributes.index - 1
        if (this.attributes.index === this.images.length) {
            this.attributes.index = 0
            fullSpin = false
        }
        if (this.attributes.index < 0) {
            this.attributes.index = this.images.length - 1
        }
        this.switcher.src = this.images[this.attributes.index]
        if (fullSpin) this.fullSpin()
    }

    fullSpin () {
        this.aFrame = requestAnimationFrame(timestamp => {
            this.step(timestamp, true)
        })
    }

    stop () {
        this.aFrame = cancelAnimationFrame(this.aFrame)
    }

    step (timestamp, fullSpin, start) {
        if (!start) start = timestamp
        let progress = timestamp - start
        if (progress < 50) {
            this.aFrame = requestAnimationFrame(timestamp => {
                this.step(timestamp, fullSpin, start)
            })
        } else {
            this.changeSrc(true, fullSpin)
        }
    }

    makeRequest (url, idx) {
        return new Promise((resolve, reject) => {
            var request = new XMLHttpRequest()
            request.open('GET', url)
            request.responseType = 'blob'
            request.onload = e => {
                if (request.status === 200) {
                    resolve(request)
                } else {
                    reject(request)
                }
            }
            request.onerror = e => {
                reject(request)
            }
            request.send()
        })
    }

    setAttributes () {
        return {
            'index': 0
        }
    }

    setSettings (data) {
        let dataSplit = data.split('|')
        let retData = {}
        retData.count = dataSplit[1].split(':')[1]
        retData.url = dataSplit[0].split(':')[1]
        retData.type = dataSplit[2].split(':')[1]
        retData.appendTo = this._elem
        if (data.indexOf('appendTo') !== -1) {
            retData.appendTo = this._elem.querySelector(dataSplit[3].split(':')[1])
        }
        return retData
    }
}

export default ThreeSixty



// WEBPACK FOOTER //
// ./src/scripts/components/ThreeSixty.js